import React from 'react';
import * as cls from './home.module.css';
import { Link } from 'react-router-dom';
import Hero from '../../ui/components/hero/hero';
import { IMG_PATH } from '../../constants';
import { ROUTES_PATHS } from '../../constants';
import { Button } from '../../ui/components/button';
import { ButtonBuyNow } from '../../ui/components/button-buy-now';
import { AsSeenOn } from './as-seen-on/as-seen-on';
import {
  Typography,
  // TypographyHighlight,
} from '../../ui/components/typography/typography';
import { Section } from '../../ui/components/section';
import { WhyChooseVoltaware } from './why-choose-voltaware';
import { TurnInsightsIntoAction } from './turn-insights-into-action';
import { PowerfulInsights } from './powerful-insights';
import { HowItWorks } from './how-it-works';
import { Reviews } from './reviews';
import { Awards } from './awards';
import { CaseStudy } from './case-study';
import { RecentBlogPosts } from './recent-blog-posts';
import { FAQ } from '../../ui/layouts/faq';
import Meta from '../../../components/meta';
import { SmarterEnergyInsights } from './smarter-energy-insights';

export const V2Home = () => {
  return (
    <>
      <Meta
        title="AI-Powered Home Energy Monitor to Track Usage and Cut Bills | Voltaware"
        description="Track your electricity use in real time with Voltaware. Our smart home energy monitor detects appliances, reduces energy waste, and helps lower your bills - all with one sensor."
      />
      <Hero
        className={cls.hero}
        items={[
          {
            img: `${IMG_PATH}/home/banner-1.png`,
            title: 'AI-Powered Smart Home Energy Monitor',
            caption: <>Track Your Energy Use - Down to Each Appliance</>,
            action: <ButtonBuyNow />,
          },
          {
            img: `${IMG_PATH}/home/banner-2.png`,
            title: 'Cut Waste. Lower Your Bills.',
            caption: (
              <>
                Appliance level insights, peer benchmarks, and Intelligent AI
                Alerts to keep you ahead.
              </>
            ),
            action: <ButtonBuyNow />,
          },
          {
            img: `${IMG_PATH}/home/banner-3.png`,
            title: 'Energy Utilities: Engage Customers, Unlock New Revenue',
            caption: (
              <>
                Use energy insights to build loyalty, improve engagement, and
                drive sustainable growth.
              </>
            ),
            action: (
              <Link to={ROUTES_PATHS.OFFER_TO_UTILITIES}>
                <Button>Explore</Button>
              </Link>
            ),
          },
        ]}
      />

      <AsSeenOn />

      <Section backgroundContrast>
        <SmarterEnergyInsights />
      </Section>

      <WhyChooseVoltaware />

      <Section backgroundContrast>
        <TurnInsightsIntoAction />
      </Section>

      <Section>
        <PowerfulInsights />
      </Section>

      <Section>
        <HowItWorks />
      </Section>

      <Reviews />

      <Section>
        <Awards />
      </Section>

      <Section backgroundContrast>
        <CaseStudy />
      </Section>

      <Section>
        <RecentBlogPosts />
      </Section>

      <FAQ />

      <Section>
        <Typography as="h2" tag="h3">
          How to Get Voltaware
        </Typography>

        <Typography style={{ maxWidth: 1050 }}>
          <strong>Are you looking for the best home energy monitor?</strong>
          <br />
          You can get started today by purchasing a Voltaware sensor from our
          Amazon store.
        </Typography>

        <ButtonBuyNow size="sm" />
      </Section>
    </>
  );
};
